import {Routes} from '@angular/router';

import {AdminLayoutComponent} from './layouts/admin/admin-layout.component';
import {AuthLayoutComponent} from './layouts/auth/auth-layout.component';
import {SuggestionsComponent} from './suggestions/suggestions.component';
import {ExtendedTableComponent} from './users/extendedtable/extendedtable.component';
import {BrandsComponent} from './brands/brands.component';
import {BrandProfileComponent} from './brand-profile/brand-profile.component';
import {ReportComponent} from './report/report.component';
import {SwearWordsComponent} from './swear-words/swear-words.component';

import {ChangePasswordComponent} from './change-password/change-password.component';
import {SubBrandsComponent} from './sub-brands/sub-brands.component';
import {AllSuggstionsComponent} from './all-suggstions/all-suggstions.component';

export const AppRoutes: Routes = [
    {
        path: 'password_reset/:reset_token',
        component: ChangePasswordComponent
    },
    {
        path: '',
        redirectTo: '/pages/login',
        pathMatch: 'full',
    }, {
        path: '',
        component: AdminLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            }, {
                path: 'users',
                component: ExtendedTableComponent
            }, {
                path: '',
                loadChildren: './userpage/user.module#UserModule'
            },
            {
                path: 'allsuggestions',
                component: AllSuggstionsComponent
            },
            {
                path: 'brands',
                component: BrandsComponent
            },
            {
                path: 'profile',
                component: BrandProfileComponent
            },
            {
                path: 'brandsuggestions',
                component: SuggestionsComponent
            }, {
                path: 'report',
                component: ReportComponent
            }, {
                path: 'language',
                component: SwearWordsComponent
            },
            {
                path: 'subbrandsuggestions',
                component: SubBrandsComponent
            },

        ]
    }, {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'pages',
            loadChildren: './pages/pages.module#PagesModule'
        }]
    }
];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts